import { Box, IconButton, Typography } from "@mui/material"
import HighlightedText from "../HighlightSearch"
import EditIcon from '@mui/icons-material/Edit';

export default function LabelPrinter({
    valor,
    titulo,
    size = "normal",
    color = '#000000',
    mostrarValor = true,
    editavel = false,
    editAcao = () => { },
    pesoValorFonte = 600,
    alignTitle = "space-between",
    alignValue = "left"
}: LabelPrinterProps) {
    return (
        <Box>
            <Box
                display="flex"
                justifyContent={alignTitle}
                alignItems="center"
            >
                <Typography color={color} fontSize={size === "small" ? 13 : 15}><HighlightedText text={`${titulo}`} /></Typography>
            </Box>
            <Box display="flex" gap={1} alignItems="center" justifyContent={alignValue}>
                <Typography color={color} fontWeight={pesoValorFonte} fontSize={size === "small" ? 17 : 22}><HighlightedText text={`${mostrarValor ? valor : "-"}`} /></Typography>

                {
                    editavel &&
                    <IconButton size="small" aria-label="delete" onClick={editAcao}>
                        <EditIcon fontSize="inherit" sx={{ color: "black" }} />
                    </IconButton>
                }
            </Box>
        </Box>
    )
}

interface LabelPrinterProps {
    titulo: string,
    valor: string,
    size?: "normal" | "small" | "large"
    mostrarValor?: boolean
    color?: string;
    editavel?: boolean,
    editAcao?: () => void,
    pesoValorFonte?: 400 | 600,
    alignTitle?: 'flex-end' | 'flex-start' | 'center' | 'space-between'
    alignValue?: 'right' | 'left' | 'center'
}